// extracted by mini-css-extract-plugin
export default {"resize":"NLLGNavbar_resize__4lsNy","construction":"NLLGNavbar_construction__jr75b"};